module.exports = __webpack_public_path__ + "static/media/funitures2.b2c0996e.svg";